import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MultiselectPageRoutingModule } from './multiselect-routing.module';

import { MultiselectPage } from './multiselect.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MultiselectPageRoutingModule
  ],
  declarations: [MultiselectPage]
})
export class MultiselectPageModule {}
